<template>
	<div>
		<CRow v-if="showConsult" class="justify-content-center">
			<CCol sm="12">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							Solicitudes Por Procesar
						</h3>
					</CCardHeader>
					<CCardBody>
						<CRow>
							<CCol>
								<span class="float-left">
									<p>
										Para procesar una solicitud debes hacer
										clic en el ícono
										<b><i class="fas fa-tasks"></i></b>
									</p>
								</span>
							</CCol>
						</CRow>
						<CRow>
							<CCol sm="12">
								<p>
									Una vez hagas clic en el ícono
									<b><i class="fas fa-tasks"></i></b> verás un
									formulario divido en 6 pasos en el cual
									podrás visualizar los datos ingresados por
									la empresa al actualizar sus datos.
								</p>
							</CCol>
							<CCol sm="12">
								<p>
									Podrás editar los datos de la empresa y a
									medida que hagas clic en <b>Siguiente</b>
									se guardará lo que hayas editado.
								</p>
							</CCol>
							<CCol sm="12">
								<p>
									<b-badge variant="danger"
										>Importante:</b-badge
									>
									Si cierras sesión o cierras la ventana
									actual del navegador sin hacer clic en
									siguiente, mientras procesas el formulario,
									no se guardará lo que hayas editado hasta el
									momento.
								</p>
							</CCol>
						</CRow>
						<CRow>
							<CCol>
								<span class="float-left">
									<p>
										<b-badge variant="info">Nota:</b-badge>
										Las solicitudes sombreadas en color
										<b>rojo</b> es por que fueron
										<b>rechazadas</b> y están a espera que
										la empresa llene nuevamente el
										formulario.
									</p>
								</span>
							</CCol>
						</CRow>
						<!-- filtro de la tabla -->
						<CRow>
							<CCol sm="4">
								<CInput
									v-model="filter"
									placeholder="Búscar"
									label="Filtrar"
								></CInput>
							</CCol>
							<CCol sm="4">
								<div role="group" class="form-group">
									<label for="urb"
										>Registros por Página</label
									>
									<multiselect
										v-model="perPage"
										:options="recordsPergPage"
										:searchable="false"
										:close-on-select="true"
										:show-labels="false"
										placeholder="Seleccione"
									>
									</multiselect>
								</div>
							</CCol>
						</CRow>
						<!-- tabla de los envios -->
						<CRow>
							<CCol sm="12">
								<p style="margin-bottom: 30px;">
									<span class="float-right"
										>Cantidad de Solicitudes:
										<CBadge shape="pill" color="info">
											{{ totalRows }}</CBadge
										>
									</span>
								</p>
								<b-table
									:fixed="true"
									v-if="showTable"
									@filtered="onFiltered"
									:filter="filter"
									stacked="lg"
									striped
									outlined
									hover
									bordered
									:current-page="currentPage"
									:per-page="perPage"
									:items="tableConsult"
									:fields="fieldsTableConsult"
								>
									<!-- width para la columna acciones -->
									<template #table-colgroup="scope">
										<col
											v-for="field in scope.fields"
											:key="field.key"
											:style="{
												width:
													field.key === 'actions'
														? '100px'
														: '',
											}"
										/>
									</template>
									<!-- progreso completado del formulario por el analista -->
									<template #cell(progress)="row">
										<b-progress
											animated
											height="2rem"
											variant="success"
											:max="6"
										>
											<b-progress-bar
												:value="row.item.progress"
												:label="
													`${(
														(row.item.progress /
															6) *
														100
													).toFixed(2)}%`
												"
											>
											</b-progress-bar>
										</b-progress>
										<small
											>Paso
											{{ row.item.progress }} completado
											de 6</small
										>
									</template>
									<!-- botones de la seccion acciones -->
									<template #cell(actions)="row">
										<b-button
											:disabled="
												row.item.statusId === 12
													? true
													: false
											"
											@click="goToProcess(row.item)"
											title="Procesar"
											pill
											variant="primary"
											size="sm"
											class="mr-1"
										>
											<i class="fas fa-tasks"></i>
										</b-button>
									</template>
								</b-table>
							</CCol>
						</CRow>
						<!-- paginacion de la tabla -->
						<CRow>
							<CCol sm="12">
								<b-pagination
									v-model="currentPage"
									:total-rows="totalRows"
									:per-page="perPage"
									align="right"
									first-number
									last-number
									pills
								>
									<template #prev-text
										><span class="text-primary"
											>Anterior</span
										></template
									>
									<template #next-text
										><span class="text-success"
											>Siguiente</span
										></template
									>
									<template #page="{ page, active }">
										<b v-if="active">{{ page }}</b>
										<i v-else>{{ page }}</i>
									</template>
								</b-pagination>
							</CCol>
						</CRow>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
		<CRow v-else class="justify-content-center">
			<CCol sm="12">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							Solicitudes Por Procesar
						</h3>
					</CCardHeader>
					<CCardBody>
						<CRow>
							<CCol>
								<span class="float-left">
									<p>No tienes solicitudes por procesar.</p>
								</span>
							</CCol>
						</CRow>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>
<script>
	import requestsForUser from '../functions/functionRequestForUsers';
	export default {
		/** Componente encargado de crear la tabla donde se muestran las solicitudes pendientes por prcesar de un usuario */
		name: 'tableForRequest',
		//title: 'Solicitudes Por Procesar | Infoguia',
		props: {
			/**Prop para indicar el tipo de request. Se debe enviar las opciones
			 * 'Massive' para envíos masivos o 'Single' para envíos individuales.
			 * Por defecto es 'Single'
			 */
			typeRequest: {
				type: String,
				default: function() {
					return 'Single';
				},
			},
			/** Prop para el id del request a consultar. Se debe enviar el id del request como numero.
			 * Solo se usa para las solicitudes de envíos masivos asignadas a los usuarios.
			 * Por defecto es '0'
			 */
			idRequest: {
				type: Number,
				default: function() {
					return 0;
				},
			},
		},
		data() {
			return {
				showConsult: true,
				fieldsTableConsult: [
					{
						key: 'bussinessName',
						label: 'Nombre de la empresa',
					},
					{
						key: 'sendedDate',
						label: 'Fecha de Envío',
					},
					{
						key: 'dateRquestRecieve',
						label: 'Fecha de recepción de la solicitud',
					},
					{
						key: 'userRequest',
						label: 'Usuario que creó la solicitud',
					},
					{
						key: 'status',
						label: 'Estatus',
					},
					{
						key: 'progress',
						label: 'Progreso del Formulario aqui',
					},
					{
						key: 'actions',
						label: 'Acciones',
					},
				],
				tableConsult: [],
				//datos de la paginacion
				currentPage: 1,
				totalRows: 0,
				perPage: 10,
				filter: '',
				recordsPergPage: [5, 10, 15, 20],
				showTable: false,
			};
		},
		created() {
			switch (this.typeRequest) {
				case 'Massive':
					this.loadMassiveRequests();
					break;
				default:
					this.loadSingleRequests();
					break;
			}
		},
		methods: {
			onFiltered(filteredItems) {
				// Metodo para actualizar el numero de paginas en el paginado a medida que se filtra
				this.totalRows = filteredItems.length;
				this.currentPage = 1;
			},
			loadSingleRequests() {
				let loader = this.$loading.show();
				requestsForUser
					.getSingleRequests()
					.then((response) => {
						if (response.length) {
							this.totalRows = response.length;
							for (
								let index = 0;
								index < response.length;
								index++
							) {
								this.tableConsult[index] = {
									bussinessName:
										response[index].busquedaempresa
											.nombreempresa,
									sendedDate: response[index].sendingDate,
									dateRquestRecieve:
										response[index].filledDateEnd,
									userRequest: response[index].user.name,
									status:
										response[index].status.name +
										' (' +
										response[index].status.description +
										')',
									idRequest: response[index].idrequests,
									idRequestRows:
										response[index].idRequestsRows,
									progress: response[index].stepFilled,
									statusId: response[index].status.idStatuses,
									_rowVariant:
										response[index].status.idStatuses == 12
											? 'danger'
											: '',
								};
							}
							if (this.tableConsult.length > 0) {
								this.showTable = true;
							}
						} else {
							this.showConsult = false;
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
			loadMassiveRequests() {
				let loader = this.$loading.show();
				this.fieldsTableConsult = this.fieldsTableConsult.filter(
					(fieldsTableConsult) => {
						return fieldsTableConsult.key !== 'userRequest';
					}
				);
				requestsForUser
					.getMassiveRequestToProcessUser(this.idRequest)
					.then((response) => {
						if (response.length) {
							this.totalRows = response.length;
							for (
								let index = 0;
								index < response.length;
								index++
							) {
								this.tableConsult[index] = {
									bussinessName:
										response[index].busquedaempresa
											.nombreempresa,
									sendedDate: response[index].sendingDate,
									dateRquestRecieve:
										response[index].filledDateEnd,
									status:
										response[index].status.name +
										' (' +
										response[index].status.description +
										')',
									idRequest: response[index].idrequests,
									idRequestRows:
										response[index].idRequestsRows,
									progress: response[index].stepFilled,
									statusId: response[index].idstatus,
									_rowVariant:
										response[index].idstatus == 12
											? 'danger'
											: '',
								};
							}
							if (this.tableConsult.length > 0) {
								this.showTable = true;
							}
						} else {
							this.showConsult = false;
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
			goToProcess(row) {
				let idRequest = row.idRequestRows;
				let stepFilled = row.progress;
				// this.$store.commit('coreuiStore/set', [
				// 	'sidebarMinimize',
				// 	true,
				// ]);
				switch (this.typeRequest) {
					case 'Massive':
						this.$router.push(
							'/massiverequestforuser/formMassiveRequest/' +
								idRequest +
								'/' +
								stepFilled
						);
						break;
					default:
						this.$router.push(
							'/singlerequests/formSingleRequest/' +
								idRequest +
								'/' +
								stepFilled
						);
						break;
				}
			},
		},
		computed: {
			minimize() {
				return this.$store.state.coreuiStore.sidebarMinimize;
			},
		},
	};
</script>
